import { getEmptyCarrito, Carrito } from '@/types/types'
import Axios, { AxiosPromise } from 'axios'

export class CarritoService {
  create (carrito: Carrito): AxiosPromise<{message: string}> {
    return Axios.post('/pedidos', carrito)
  }

  update (carrito: Carrito): AxiosPromise<{message: string}> {
    return Axios.put('/pedidos', carrito)
  }

  getEmpty (id = '') {
    return getEmptyCarrito(id)
  }

  getDatosCliente (documento_identidad: string) {
    if (documento_identidad.length === 10) {
      return Axios.post('https://ceslyweb.com/servicio/getdni.php', { dni: documento_identidad })
    } else {
      return Axios.post('https://ceslyweb.com/servicio/getdni.php', { dni: documento_identidad })
    }
  }
}
